<template>
  <div class="mt-2">
    最新の検収ステータス：
    <span class="font-weight-bold">{{
      inspectionI18ns.status[inspection.status]
    }}</span>
    <div v-if="inspection.status == 'completed'" class="my-2">
      <div class="caption">
        検収結果：
        <v-chip
          class="font-weight-bold"
          small
          label
          dark
          :color="resultColor[inspection.result]"
        >
          {{ inspectionI18ns.result[inspection.result] }}
        </v-chip>
      </div>
    </div>
    <div class="mt-1">
      <span class="caption">納品日時：{{ inspection.createdAt | moment }}</span>
    </div>
    <div class="mt-1">
      <span class="caption"
        >検収開始日時：{{ inspection.startsAt | moment }}</span
      >
    </div>
    <div class="mt-1">
      <span class="caption"
        >検収完了日時：{{ inspection.completedAt | moment }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import snakecaseKeys from 'snakecase-keys'

export default {
  filters: {
    moment: function (date) {
      if (date == null) {
        return ''
      }
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      resultColor: {
        publish: 'success',
        remand: 'error',
        close: 'warning'
      }
    }
  },
  computed: {
    ...mapState({
      inspectionI18ns: (state) => snakecaseKeys(state.I18n.enums.inspection)
    })
  },
  methods: {
    i18nInspectionStatus (inspection) {
      return snakecaseKeys(this.inspectionI18ns.status, {'deep': true})[inspection.status]
    }
  }
}
</script>
